let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1vGr8")).then(() => parcelRequire('hbFR0'));